import { Handle, Position } from '@xyflow/react';
import { X } from 'lucide-react';

export const MetricWidget = ({ data }) => {
  return (
    <div className="bg-card border border-border rounded-xl shadow-elevated p-3 w-[160px] group relative cursor-grab hover:shadow-lg transition-all duration-200 animate-in fade-in-0 zoom-in-95">
      <Handle type="target" position={Position.Bottom} className="!opacity-0 !w-0 !h-0" />

      {/* Remove button — visible on hover */}
      <button
        onClick={(e) => { e.stopPropagation(); data.onRemove?.(); }}
        className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-red-500 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-600 z-10"
      >
        <X className="h-3 w-3" />
      </button>

      {/* Source node label */}
      <div className="text-[9px] font-semibold text-muted-foreground uppercase tracking-wide">
        {data.nodeLabel}
      </div>

      {/* Metric label */}
      <div className="text-[10px] text-muted-foreground mt-0.5">{data.label}</div>

      {/* Metric value */}
      <div
        className="text-2xl font-extrabold tracking-tight mt-1 text-chart-1"
        style={{ fontVariantNumeric: 'tabular-nums' }}
      >
        {data.value}
      </div>
    </div>
  );
};
